import React, { Component } from 'react'
import classnames from 'classnames'
import { Icon, ToolTip } from '@driftt/tide-core-legacy'
import * as TrackingActions from 'app/modules/tracking/actions'
import * as UserSelectors from 'app/modules/user/selectors'
import { BEAMER_EMBED_ID } from 'constants/ResourcesConstants'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getBeamerFilters } from 'utils/beamer'
import { getAllIntegrations } from 'utils/Integrations'

import './style.styl'

const mapStateToProps = state => ({
  firstName: UserSelectors.currentUserFirstName(state),
  lastName: UserSelectors.currentUserLastName(state),
  email: UserSelectors.currentUserEmail(state),
  id: UserSelectors.currentUserId(state),
  currentOrgUsers: UserSelectors.currentOrgUsers(state),
  integrations: getAllIntegrations(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      track: TrackingActions.track,
    },
    dispatch,
  ),
})


class Shipyard extends Component {
  constructor(props) {
    super(props)

    const { track } = props.actions
    const { firstName, lastName, email, id, currentOrgUsers, integrations } = props
    let showShipyard = true

    window.beamer_config = {
      selector: ".rocket-link",
      product_id: BEAMER_EMBED_ID,
      bounce: false,
      button_position: 'top-left',
      onclick: (url) => track('Beamer Item Selected', { url }),
      top: -6,
      right: -6,
      user_firstname: firstName,
      user_lastname: lastName,
      user_email: email,
      user_id: id,
      filter_by_url: true,
      filter: getBeamerFilters(currentOrgUsers, integrations).join(';'),
    }

    try {
      window.Beamer.init()
    } catch(e) {
      console.warn(e)
      showShipyard = false
    }

    this.state = {
      showShipyard,
      hasBeamerBootstrapped: false
    }
  }

  componentDidUpdate(prevProps) {
    const { currentOrgUsers, integrations } = this.props
    if(prevProps.currentOrgUsers !== currentOrgUsers || prevProps.integrations !== integrations) {
      window.beamer_config.filter = getBeamerFilters(currentOrgUsers, integrations).join(';')
    }
  }

  render() {
    const { showShipyard } = this.state
    return (
      <div
        onClick={() => this.props.actions.track('Beamer Opened')}
        className={
          classnames(
            'rocket-link',
            { 'hide-shipyard': !showShipyard }
          )}>
        <ToolTip component={'Product Updates'} flow="right">
          <div className="nav-status-icon-wrapper">
            <Icon width={16} height={16} name="rocket"/>
          </div>
        </ToolTip>
      </div>
    )
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(Shipyard)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/Shipyard/index.js